import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum UploadStatus {
  PENDING = 'PENDING',
  UPLOADING = 'UPLOADING',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  CANCELLED = 'CANCELLED'
}

export interface FileUploadStatus {
  fileName: string;
  status: UploadStatus;
  progress: number;
  error?: string;
}

interface UploadState {
  progress: number;
  fileStatuses: FileUploadStatus[];
}

const initialState: UploadState = {
  progress: 0,
  fileStatuses: [],
};

export const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    startUpload: (state, action: PayloadAction<string[]>) => {
      state.progress = 0;
      state.fileStatuses = action.payload
        .map((fileName: string): FileUploadStatus => ({
          fileName,
          status: UploadStatus.PENDING,
          progress: 0,
        }));
    },
    uploadFile: (state, action: PayloadAction<{ fileName: string; file: File }>) => {

      const fileStatus = state.fileStatuses
        .find((status) => status.fileName === action.payload.fileName);

      if (fileStatus)
        fileStatus.status = UploadStatus.UPLOADING;
    },
    fileUploadSuccess: (state, action: PayloadAction<string>) => {

      const fileStatus = state.fileStatuses
        .find((status) => status.fileName === action.payload);

      if (fileStatus) {
        fileStatus.status = UploadStatus.COMPLETED;
        fileStatus.progress = 100;
      }
    },
    fileUploadError: (state, action: PayloadAction<string>) => {

      const fileStatus = state.fileStatuses
        .find((status) => status.fileName === action.payload);

      if (fileStatus) {
        fileStatus.status = UploadStatus.ERROR;
        fileStatus.progress = 100;
      }
    },
    updateFileProgress: (state, action: PayloadAction<{ fileName: string; progress: number }>) => {
      const fileStatus = state.fileStatuses
        .find((status) => status.fileName === action.payload.fileName);

      if (fileStatus) {
        fileStatus.progress = action.payload.progress;
      }
    },
    fileUploadStop: (state, action: PayloadAction<string >) => {
      const fileStatus = state.fileStatuses
        .find((status) => status.fileName === action.payload);

      if (fileStatus) {
        fileStatus.status = UploadStatus.CANCELLED;
        fileStatus.progress = 100;
      }
    },
    updateProgress: (state, action: PayloadAction< number>) => {
      state.progress = action.payload;
    },
    stopUpload: (state) => {},
    resetUpload: (state) => {
      return initialState;
    },
  },
});

export const {
  startUpload,
  uploadFile,
  fileUploadSuccess,
  fileUploadError,
  updateFileProgress,
  updateProgress,
  fileUploadStop,
  stopUpload,
  resetUpload,
} = uploadSlice.actions;

export default uploadSlice.reducer;
